import './Header.css';
import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';

function Header() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div id="Header">
      <div className='Header-background'/>
      <div id="Header-logo" onClick={() => navigate('/')}>
        <img id="Header-img" src={process.env.PUBLIC_URL + '/images/base/HMP_logo.webp'} alt=""/>
      </div>

  {window.innerWidth < 1200 ?
  <div>

    <div id="Header-dropdown">
      <button className="dropbtn" onClick={toggleDropdown}>Menu</button>
      {isOpen && (
        <div className="dropdown-content">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a id="Header-button-about" onClick={() => navigate('/Profile')}>
            Profile
          </a>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a id="Header-button-about" onClick={() => navigate('/Research')}>
            Research
          </a>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a id="Header-button-about" onClick={() => navigate('/Projects')}>
            Projects
          </a>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a id="Header-button-about" onClick={() => navigate('/Gallery')}>
            Gallery
          </a>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          {/* <a id="Header-button-about" onClick={() => navigate('/Blog')}>
            Blog
          </a> */}
        </div>
      )}
    </div>


        <div id="Header-buttonlist-dropdown">        
          <div className='Header-button'>
            <a href="https://github.com/hpotechius">
              <img id="Header-linkedin-img" src={process.env.PUBLIC_URL + '/images/base/github.webp'} alt=""/>
            </a>
          </div>  
        <div className='Header-button'>
          <a href="https://orcid.org/0009-0007-3081-5584">
          <img id="Header-linkedin-img" src={process.env.PUBLIC_URL + '/images/base/orcid_icon.webp'} alt=""/>
          </a>
        </div>  
          {/* <div className='Header-button'>
            <a href="https://www.linkedin.com/in/herbert-p-2154a1216">
              <img id="Header-linkedin-img" src={process.env.PUBLIC_URL + '/linkedin.webp'} alt=""/>
            </a>
          </div> */}
        </div>
    </div>
    :




      <div id="Header-buttonlist">
        <div className='Header-button' id="Header-button-about" onClick={() => navigate('/Profile')}>
          Profile
        </div>
        <div className='Header-button' id="Header-button-publications" onClick={() => navigate('/Research')}>
          Research
        </div>
        <div className='Header-button' id="Header-button-projects" onClick={() => navigate('/Projects')}>
          Projects
        </div>
        <div className='Header-button' id="Header-button-projects" onClick={() => navigate('/Gallery')}>
          Gallery
        </div>
        {/* <div className='Header-button' id="Header-button-contact" onClick={() => navigate('/Blog')}>
          Blog
        </div>       */}
        <div className='Header-button'>
          <a href="https://github.com/hpotechius">
          <img id="Header-linkedin-img" src={process.env.PUBLIC_URL + '/images/base/github.webp'} alt=""/>
          </a>
        </div>  
        <div className='Header-button'>
          <a href="https://orcid.org/0009-0007-3081-5584">
          <img id="Header-linkedin-img" src={process.env.PUBLIC_URL + '/images/base/orcid_icon.webp'} alt=""/>
          </a>
        </div>  
        {/* <div className='Header-button'>*/}
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
           {/* <a href="https://www.linkedin.com/in/herbert-p-2154a1216">
          <img id="Header-linkedin-img" src={process.env.PUBLIC_URL + '/linkedin.webp'} alt=""/>
          </a>
        </div> */}
      </div>
    }
    </div>
  );
}

export default Header;
